import React from 'react';
import { audiences } from '../data/materials';
export function AudienceSection() {
  return <section className="py-10 px-4 bg-white" data-id="element-23" data-mp="n18ae95dvxrl">
      <div className="max-w-4xl mx-auto" data-id="element-24" data-mp="mzx3w1kk0bws">
        <h2 className="text-[20px] md:text-2xl font-black text-[#14356B] text-center mb-6" data-id="element-25" data-mp="s0ujq7i3ctv4">
          IDEAL PARA:
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-26" data-mp="wymnbys3m4f5">
          {audiences.map(audience => <div key={audience.label} className="flex items-center gap-3 bg-gray-50 border border-gray-200 rounded-2xl px-5 py-4" data-id="element-27" data-mp="3vicuamp90ez8">
              <span className="text-2xl flex-shrink-0" aria-hidden="true" data-id="element-28" data-mp="48xkdfvtvuaw">
                {audience.emoji}
              </span>
              <span className="text-base font-bold text-gray-800" data-id="element-29" data-mp="e0jsh3cvdd9f">
                {audience.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}